import { render } from "./UnAuthorized.vue?vue&type=template&id=18ff3d6a"
import script from "./UnAuthorized.vue?vue&type=script&lang=js"
export * from "./UnAuthorized.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__